<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->


<ng-progress></ng-progress>

<iric-ui-blocker-overlay-component></iric-ui-blocker-overlay-component>

<div class='toolbar my-none card'>
  <h2 class='px'>
    <a [routerLink]="shouldSetLogoRouterLink ? '/' : null" class='title' data-testid="should-set-logo-router-link">
      <img src='assets/top_logo.png' height='32px'>
    </a>
  </h2>
  <div class='right'>
    <ng-container *ngrxLet='items$ as items'>
      <p-menubar *ngIf='items.length' styleClass='apps-menu' [model]='items | menuItemHasAnyRights'>
      </p-menubar>
    </ng-container>

    <mpm-notification-ui-button></mpm-notification-ui-button>
  </div>
</div>
<div class='pseudo-toolbar'>
</div>

<ng-container *ngIf='isPaymentTermOverdue'>
  <div class='card my-none banner'>
    <h3>{{ 'paymentTermBannerMessage' | translate }}</h3>
  </div>
  <div class='pseudo-toolbar'>
  </div>
</ng-container>


<div [@move]=currentState wellPreventScrollOnRouterOutlet>
  <div class='page-min-height'>
    <router-outlet></router-outlet>
  </div>
</div>

<div *ngIf='accessUnavailableFeatures'>
  <well-footer [loggedInUser]='loggedInUser'></well-footer>
</div>

<div>
  <router-outlet name='popup-full'></router-outlet>
</div>

<div>
  <router-outlet name='popup'></router-outlet>
</div>

<div>
  <router-outlet (activate)='onActivate()'
                 (deactivate)='onDeactivate()'

                 name='right-side'></router-outlet>
</div>
<div>
  <router-outlet name='sidebar'></router-outlet>
</div>

<p-toast [style]="{marginTop: '50px'}" key='global-notification' />

<p-toast [style]="{marginTop: '80px', width: '70%'}" position='top-right' key='global-error' [autoZIndex]='true'
         [baseZIndex]='20100'>
  <ng-template let-message pTemplate='message'>
    <span [class]="'p-toast-message-icon pi' + (message.icon ? ' ' + message.icon : '')" [ngClass]="{'pi-info-circle': message.severity === 'info', 'pi-exclamation-triangle': message.severity === 'warn',
        'pi-times-circle': message.severity === 'error', 'pi-check' :message.severity === 'success'}"></span>
    <div class='p-toast-message-text'>
      <div class='p-toast-summary'>
        <ng-container *ngIf='message?.data?.translatable; else plain'>
          {{ message.summary | translate }}
        </ng-container>
        <ng-template #plain>
          {{ message.summary }}
        </ng-template>
      </div>
      <div class='p-toast-detail pre-line'>{{ message.detail }}</div>
    </div>
  </ng-template>
</p-toast>

<issue-reporter [appContext]='appContext | json'></issue-reporter>




